import React from 'react'
import PropTypes from 'prop-types'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Box from '@material-ui/core/Box'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'
import LinesEllipsis from 'react-lines-ellipsis'
import ButtonCta from '@components/atoms/button-cta'
import stripMarkdown from '@lib/strip-markdown'
import Link from 'next/link'
import secureLink from '../../../utils/secureLink'
import useStyles from './academy-coach-card.styles'

const readMoreButton = (coach, isHOPECoach, classes) => {
  if (isHOPECoach) return null
  if (coach?.profileUrl) {
    return (
      <ButtonCta
        variant="text"
        color="primary"
        size="small"
        arrow
        className={classes.button}
        href={coach.profileUrl}
      >
        Read More
      </ButtonCta>
    )
  }
  return null
}

const AcademyCoachCard = ({ coach, isSolo = false, isHOPECoach = false }) => {
  const classes = useStyles()
  const { name, coachProfile } = coach
  const { title, profilePhoto, bio } = coachProfile || {}

  const initials = name.match(/(\b\S)?/g).join('').match(/(^\S|\S$)?/g).join('')

  return (
    <Card className={`${classes.card} ${isHOPECoach ? classes.hopeCard : ''} ${isSolo ? classes.soloCard : ''}`}>
      <Link href={!isHOPECoach && coach?.profileUrl ? coach.profileUrl : '#0'}>
        <Box alignItems="center" display="flex" flexDirection="column" height={isHOPECoach ? '232px' : '18rem'}>
          <Avatar
            aria-label="coach"
            className={classes.avatar}
            src={secureLink(profilePhoto)}
            alt={name}
          >
            {initials}
          </Avatar>
          <CardContent>
            <Typography variant="h5">
              {name}
            </Typography>
            {title && (
              <Typography variant="subtitle1" className={classes.title}>
                {title}
              </Typography>
            )}
            {!isHOPECoach && (
              <Box className={classes.bioContainer}>
                {bio && (
                  <LinesEllipsis
                    maxLine={3}
                    text={stripMarkdown(bio)}
                    className={classes.bio}
                  />
                )}
              </Box>
            )}
          </CardContent>
        </Box>
      </Link>
      {readMoreButton(coach, isHOPECoach, classes)}
    </Card>
  )
}

AcademyCoachCard.propTypes = {
  coach: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    bookingUrl: PropTypes.string,
    coachProfile: PropTypes.shape({
      bio: PropTypes.string,
      profilePhoto: PropTypes.string,
      title: PropTypes.string,
    }),
    profileUrl: PropTypes.string,
  }).isRequired,
  isSolo: PropTypes.bool,
  isHOPECoach: PropTypes.bool,
}

export default AcademyCoachCard
